import {
  HostingResourcesAction,
  LOAD_HOSTING_RESOURCES,
  LOAD_HOSTING_RESOURCES_FAIL,
  LOAD_HOSTING_RESOURCES_SUCCESS,
  LOAD_HOSTING_RESOURCES_BY_WEBSITE,
  LOAD_HOSTING_RESOURCES_BY_WEBSITE_FAIL,
  LOAD_HOSTING_RESOURCES_BY_WEBSITE_SUCCESS,
  LoadHostingResourcesSuccess,
  LoadHostingResourcesByWebsiteSuccess
} from "../actions";

export interface IHostingResourcesState {
  hostingResources: any;
  entities: any;
  loading: boolean;
  loaded: boolean;
}

export const initialState: IHostingResourcesState = {
  hostingResources: {},
  entities: {},
  loading: false,
  loaded: false
};

export function reducer(state: IHostingResourcesState = initialState, action: HostingResourcesAction): IHostingResourcesState {
  let payload: any;

  switch (action.type) {
    case LOAD_HOSTING_RESOURCES:
      return {
        ...state,
        loading: true,
        loaded: false
      };

    case LOAD_HOSTING_RESOURCES_SUCCESS:
      payload = (<LoadHostingResourcesSuccess>action).payload;

      return {
        ...state,
        hostingResources: payload,
        loading: false,
        loaded: true
      };

    case LOAD_HOSTING_RESOURCES_FAIL:
      return {
        ...state,
        hostingResources: null,
        loading: false,
        loaded: true
      };



    case LOAD_HOSTING_RESOURCES_BY_WEBSITE:
      payload = (<LoadHostingResourcesByWebsiteSuccess>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload]: {
            ...state[payload],
            loading: true,
            loaded: false
          }
        }
      };

    case LOAD_HOSTING_RESOURCES_BY_WEBSITE_SUCCESS:
      payload = (<LoadHostingResourcesByWebsiteSuccess>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            entities: payload.entities,
            loading: false,
            loaded: true
          }
        }
      };

    case LOAD_HOSTING_RESOURCES_BY_WEBSITE_FAIL:
      payload = (<LoadHostingResourcesByWebsiteSuccess>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            loading: false,
            loaded: true
          }
        }
      };

  }

  return state;
}
